"use client";
import posthog from "posthog-js";

export const handleButtonTracking = async (description) => {
  if (typeof window !== "undefined" && window.location.hostname === "localhost")
    return;
  posthog.capture(description);
};
